export function convertToIST(utcTimestamp) {
  const options = {
    timeZone: "Asia/Kolkata",
    hour12: true,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  const istTime = new Date(utcTimestamp).toLocaleString("en-US", options);
  return istTime;
}

export function formatDate(dateString) {
  // Split the date string by "/"
  var parts = dateString.split("/");

  // Extract day, month, and year
  var day = parseInt(parts[0]);
  var month = parseInt(parts[1]);
  var year = parseInt(parts[2]);

  // Define an array of month names
  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get the month name
  var monthName = monthNames[month - 1]; // Adjust for zero-based index

  // Return formatted date
  return day + " " + monthName + " " + year;
}

export function formatDate1(dateString) {
  // Split the date string into year, month, and day
  var parts = dateString.split("-");
  var year = parts[0];
  var month = parts[1];
  var day = parts[2];

  // Create a new date object with the given year, month, and day
  var formattedDate = new Date(year, month - 1, day);

  // Extract the month, day, and year from the formatted date
  var formattedMonth = formattedDate.getMonth() + 1;
  var formattedDay = formattedDate.getDate();
  var formattedYear = formattedDate.getFullYear();

  // Return the formatted date in "M/D/YYYY" format
  return formattedMonth + "/" + formattedDay + "/" + formattedYear;
}
